export const config = {
    appId: process.env.REACT_APP_APP_ID || 'e2a4c621-c394-4e57-9150-4ef52207f461',
    redirectUri: process.env.REACT_APP_URL_HOST || 'http://localhost:3000',
    postLogoutRedirectUri: process.env.REACT_APP_URL_HOST || 'http://localhost:3000',
    policies: {
        names: {
            signUpSignIn: 'B2C_1A_signup_signin',
            forgotPassword: 'B2C_1A_NEWPASSWORD',
            impersonation: 'B2C_1A_Impersonation'
        },
        authorities: {
            signUpSignIn: {
                authority: process.env.REACT_APP_SIGN_UP_AUTHORITY || 'https://delfiauthqav2.b2clogin.com/delfiauthqav2.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN'
            },
            forgotPassword: {
                authority: process.env.REACT_APP_FORGOT_AUTHORITY || 'https://delfiauthqav2.b2clogin.com/delfiauthqav2.onmicrosoft.com/B2C_1A_NEWPASSWORD'
            },
            impersonation: {
                authority: process.env.REACT_APP_IMPERSONATION_AUTHORITY || 'https://delfiauthqa.b2clogin.com/delfiauthqa.onmicrosoft.com/B2C_1A_IMPERSONATION'
            }
        },
    },
    scopes: ['openid', 'profile'],
    scopeDNS: process.env.REACT_APP_SCOPE_DNS || 'https://delfiauthqav2.onmicrosoft.com'
  };